import type { StateCreator } from 'zustand';
import type { FeedbackEntry } from '@abs/shared-types';
import { generateId } from '@/utils/id';

export interface FeedbackSlice {
  feedbackEntries: FeedbackEntry[];

  addFeedback: (feedback: Omit<FeedbackEntry, 'id' | 'createdAt'>) => string;
  clearFeedback: () => void;
}

export const createFeedbackSlice: StateCreator<FeedbackSlice> = (set) => ({
  feedbackEntries: [],

  addFeedback: (feedbackData) => {
    const id = generateId();
    const entry: FeedbackEntry = {
      ...feedbackData,
      id,
      createdAt: new Date().toISOString(),
    };
    set((state) => ({
      feedbackEntries: [...state.feedbackEntries, entry],
    }));
    return id;
  },

  clearFeedback: () => {
    set({ feedbackEntries: [] });
  },
});
